module.exports = "input[type=file] :disabled {\n  background-color: grey;\n}"